export default function (value, language) {
  let year = value.slice(0, 4);
  if (language === "ja") {
    year += "年";
  } else if (language === "ko") {
    year += "년";
  }

  let formattedYear = year + value.slice(4);
  return formattedYear;
}
